import styled from 'styled-components'

import { Sizes, Breakpoints, Colors, FontRegular, FontLight } from './../../utils/variables'

export const FormWrapper = styled.form`
    width: 100%;
    max-width: ${Sizes.maxContentWidth};

    margin: 0 auto;

    padding: 0 30px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        padding: 0;
    }
`

export const InputWrapper = styled.div`
    margin-bottom: 30px;

    &:last-of-type {
        margin-bottom: 0;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 60px;
    }
`

export const InputLabel = styled.label`
    display: block;

    margin-bottom: 15px;

    ${FontRegular}
    font-size: 13px;
    line-height: 1em;

    color: ${Colors.grey};

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 15px;

        font-size: 14px;
    }
`

export const Input = styled.input`
    display: block;

    width: 100%;

    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    outline: none;

    ${FontLight}
    font-size: 14px;
    line-height: 25px;

    color: ${Colors.black};

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 17px;
        line-height: 40px;
    }
`

export const TextArea = styled.textarea`
    display: block;

    width: 100%;

    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    outline: none;

    ${FontLight}
    font-size: 14px;
    line-height: 25px;

    color: ${Colors.black};

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 17px;
        line-height: 25px;
    }
`

export const Submit = styled.input`
    display: inline-block;

    padding: 15px 45px;

    background-color: ${Colors.blue};
    border: none;
    border-radius: 0;

    ${FontLight}
    font-size: 14px;
    line-height: 1em;
    letter-spacing: 1px;

    color: ${Colors.white};

    text-transform: uppercase;
`